//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//
/**
 * Created by z003f2zh on 26.04.2016.
 */

(function () {

    'use strict';

    angular.module('container.core')
        .factory('webSocketService', webSocketService);

    function webSocketService() {

        var service = {};

        var socket = null;

        service.connect = function () {
        };

        return service;
    }
})();